import { render, staticRenderFns } from "./ShareProductModal.vue?vue&type=template&id=32a6a2f1&scoped=true&"
import script from "./ShareProductModal.vue?vue&type=script&lang=js&"
export * from "./ShareProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareProductModal.vue?vue&type=style&index=0&id=32a6a2f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6a2f1",
  null
  
)

export default component.exports